import { Directive, Input, EventEmitter, Output } from '@angular/core';
import { ImmomioIconName } from '../../models';

@Directive()
export abstract class InfoBaseComponent {
  @Input() context: {
    title: string;
    content: string;
  };
  @Output() tapped = new EventEmitter();
  public immomioIconName = ImmomioIconName;
}
